import { ILoggerContextProvider, LoggerEnvironmentInfo, LoggerSessionInfo } from "co-addin-logging-build";
import { selectCpmUsername, selectTenantId } from "../../redux/feature/settings/configurations-slice";
import { DocPropKeys, retrieveDocumentProp } from "../../utils/helpers/CustomXmlHelper";
import releaseNotes from "../../../../../assets/json/releaseNote.json";
import { v4 as uuidv4 } from "uuid";
import { isOnWordWeb } from "../../api/config/ExternalConfig";

export class WordLoggerContextProvider implements ILoggerContextProvider {
  private readonly sessionId: string;

  constructor(private readonly store: any) {
    this.sessionId = uuidv4();
  }

  getUser(): string | undefined {
    const state = this.store.getState();
    return selectCpmUsername(state);
  }

  getTenantId(): string | undefined {
    const state = this.store.getState();
    return selectTenantId(state);
  }

  async getDocumentId(): Promise<string | undefined> {
    try {
      return await retrieveDocumentProp(DocPropKeys.DocumentId);
    } catch {
      return undefined;
    }
  }

  async getEnvironmentInfo(): Promise<LoggerEnvironmentInfo> {
    if (typeof Office !== "undefined" && Office.context) {
      return {
        addinType: Office.context.diagnostics?.host?.toString(),
        platform: Office.context.diagnostics?.platform?.toString(),
        officeVersion: Office.context.diagnostics?.version,
        officeToolType: isOnWordWeb() ? "WEB" : "APP",
        browserInfo: navigator?.userAgent,
      };
    }
    return {
      browserInfo: navigator?.userAgent,
    };
  }

  getSessionInfo(): LoggerSessionInfo {
    return {
      sessionId: this.sessionId,
      userAgent: navigator?.userAgent || "unknown",
      addinVersion: releaseNotes[0]?.version || "unknown",
    };
  }
}
